import { render } from "./BookingEdit.vue?vue&type=template&id=28e15160&scoped=true"
import script from "./BookingEdit.vue?vue&type=script&lang=js"
export * from "./BookingEdit.vue?vue&type=script&lang=js"

import "./BookingEdit.vue?vue&type=style&index=0&id=28e15160&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e15160"]])

export default __exports__